var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("\n   "+_vm._s(_vm.label)+"\n   "),(_vm.showTooltip)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.html",modifiers:{"hover":true,"html":true}}],staticClass:"ml-1 text-info",attrs:{"title":_vm.tooltipLabel}},[_c('i',{staticClass:"fas fa-info-circle"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }